import MapMixpanelProvider from '@map/components/app/MapMixpanelProvider';
import NavigationHistoryProvider from '@map/components/app/NavigationHistoryProvider';
import ZendeskHelpProvider from '@map/components/app/ZendeskHelpProvider';
import MixpanelPropertyUpdater from '@map/components/MixpanelPropertyUpdater';
import { ProviderProps, Provider as StoreProvider } from 'react-redux';
import LocalizationProvider from './LocalizationProvider';
import RoutingProvider from './RoutingProvider';
import ThemeProvider from './ThemeProvider';

const MasterProvider = ({ children, ...props }: ProviderProps) => (
  <StoreProvider {...props}>
    <LocalizationProvider>
      <ThemeProvider>
        <MapMixpanelProvider>
          <MixpanelPropertyUpdater />
          <RoutingProvider>
            <NavigationHistoryProvider>
              <ZendeskHelpProvider fallbackKeywords={['m:global_fallback']}>
                {children}
              </ZendeskHelpProvider>
            </NavigationHistoryProvider>
          </RoutingProvider>
        </MapMixpanelProvider>
      </ThemeProvider>
    </LocalizationProvider>
  </StoreProvider>
);

export default MasterProvider;
